<template>
  <v-container>
    <p class="pt-4 mb-1 font-weight-bold text-h3">{{ product_name }}</p>
    <v-card class="overflow-y-auto" max-height="500" width="500" elevation="0">
      <v-img
        class="mx-auto mb-2"
        width="300"
        max-height="300"
        :src="getImgSrc()"
      ></v-img>
      <v-card-subtitle
        class=" pa-3 orange darken-2 webshop_modal_productdisplay_price"
      >
        <span class=" white--text text-h3"
          >{{ this.$t("thead.price") }}: €{{
            (product_price / 100).toFixed(2)
          }}</span
        >
      </v-card-subtitle>
      <v-card-subtitle
        class=" pl-3 pr-3 pb-1 pt-3 webshop_modal_productdisplay_info"
      >
        <span class="font-weight-bold text-h3">{{
          this.$t("thead.product_information")
        }}</span>
      </v-card-subtitle>
      <v-card-text class=" pl-3 pr-3 pt-1">
        <span class="product-description">{{ product_description }}</span>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  props: {
    product_name: {
      type: String,
      required: true
    },
    product_image: {
      type: String
    },
    product_price: {
      type: Number,
      required: true
    },
    product_description: {
      type: String
    }
  },
  methods: {
    getImgSrc() {
      if (this.product_image) {
        return this.$store.state.config.imgUrl + this.product_image;
      }
      if (this.$store.state.config.webshop_configuration.default_image_url) {
        return (
          this.$store.state.config.imgUrl +
          this.$store.state.config.webshop_configuration.default_image_url
        );
      }
      return null;
    }
  }
};
</script>
<style>
.product-description {
  white-space: pre-line;
}
</style>
